import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { Page } from 'src/app/shared/models/page';
import { Observable,from } from 'rxjs';
import { PagedData } from 'src/app/shared/models/paged-data';
import { Buyer, BuyerUpdateResult, BuyerValidationResult } from 'src/app/shared/models/buyer.model';
import { HttpParams } from '@angular/common/http';
import { PageParams } from 'src/app/shared/common/Enums';
import { catchError, map, tap } from 'rxjs/operators';
import { ApiUrlConstants } from "src/app/shared/common/ApiUrlConstants";
import { RfqTokenAuthService } from 'src/app/shared/services/rfq-token-auth.service';

@Injectable({
  providedIn: 'root'
})
export class BuyerService {
 
  constructor(
    private webApiService: WebApiService,
    private snack: MatSnackBar,
    private rfqTokenAuth: RfqTokenAuthService
  ) { }

  /**
   * Get all suppliers list with paginated options.
   * @param pageMetadata Page Metadata i.e. PAGE OFFSET, PAGE SIZE, TOTAL PAGES etc..
   */
  getPaginatedBuyers(pageMetadata: Page): Observable<PagedData<Buyer>> {
    let apiUrl = "/buyer/";

    /**
     * Set request params for pagination variables.
     * @pageNumber Add +1 in PageNumber as page start with 0 in frontend data-table.
     */
    let params = new HttpParams()
      .set(PageParams.limit, pageMetadata.size)
      .set(PageParams.page, pageMetadata.pageNumber + 1)
      .set(PageParams.searchParam, pageMetadata.serachParam)
      .set(PageParams.isDelete, pageMetadata.isDelete)
      .set(PageParams.sortColoumn, pageMetadata.sortColoumn)
      .set(PageParams.sortOrder, pageMetadata.sortOrder);

    return this.webApiService
      .getPaginatedRequest<PagedData<Buyer>>(apiUrl, params)
      .pipe(
        map((paginatedBuyer) => {
          // Set page metadata for frontend table properties
          paginatedBuyer.page.totalElements = paginatedBuyer.count;
          paginatedBuyer.page.size = pageMetadata.size;
          paginatedBuyer.page.totalPages = Math.floor(
            paginatedBuyer.count / pageMetadata.size
          );
          paginatedBuyer.page.pageNumber = pageMetadata.pageNumber;
          paginatedBuyer.page.serachParam = pageMetadata.serachParam;
          return paginatedBuyer;
        })
      );
  }

  /**
   * Get all suppliers list.
   */
  getAllBuyers(): Promise<Buyer[]> {
    let apiUrl = "/buyer/";
    return this.webApiService.getRequest<Buyer[]>(apiUrl);
  }

  /**
   * Get supplier detail by supplier id.
   * @param _buyerId Supplier Id.
   */
  getBuyerById(_buyerId: number): Promise<Buyer> {
    let apiUrl = `/buyer/${_buyerId}`;
    return this.webApiService.getRequest<Buyer>(apiUrl);
  }

  /**
   * Add new supplier.
   * @param _buyerDetail Supplier form data.
   */
  addBuyer(_buyerDetail: Buyer, buyerId?: any): Promise<any> {
    let apiUrl = `/buyer/add`;
    return this.webApiService.postRequest<any>(apiUrl, { ..._buyerDetail, buyerId });
  }

  /**
   * Update any existing supplier details by supplier id.
   * @param _buyerId To be updated supplier id.
   * @param _buyerDetail Supplier form data.
   */
  updateBuyer(_buyerId: number, _buyerDetail: Buyer): Promise<Buyer> {
    let apiUrl = `/buyer/add`;
    return this.webApiService.postRequest<Buyer>(apiUrl, {..._buyerDetail,_buyerId})
  };
  

  /**
 * Update any existing supplier details by supplier id.
 * @param _buyerId To be updated supplier id.
 * @param _buyerDetail Supplier form data.
 */
  validateBuyerName(emailAddressArr: string[]): Promise<BuyerValidationResult> {
    let apiUrl = `/buyer/validate`;
    const emailAddresses = { emailAddressArr };
    return this.webApiService.postRequest<BuyerValidationResult>(apiUrl, emailAddresses);
  }

  /**
* Update any existing supplier details by supplier id.
* @param _buyerId To be updated supplier id.
* @param _buyerDetail Supplier form data.
*/
  getBuyerUpdateDataByUserId(_userId: any): Promise<BuyerUpdateResult> {
    let apiUrl = `/buyer/fetch/userid/${_userId}`;
    return this.webApiService.getRequest<BuyerUpdateResult>(apiUrl);
  }

  getSearchResult(searchTerms: any): Promise<any> {
    let apiUrl = `/buyer/search/${searchTerms}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  /**
   * Remove any existing supplier by supplier id.
   * @param _buyerId To be removed supplier id.
   */
  deleteBuyer(_buyerId: number): Promise<any> {
    let apiUrl = `/buyer/fetch/userid/${_buyerId}`;
    return this.webApiService.deleteRequest<any>(apiUrl);
  }

  //Restore
  restoreBuyer(_buyerId: number): Promise<Buyer> {
    let apiUrl = `/buyer/restore/${_buyerId}`;
    return this.webApiService.putRequest<Buyer>(apiUrl, { _buyerId: _buyerId });
  }

  /**
   * Get all suppliers list with paginated options.
   * @param pageMetadata Page Metadata i.e. PAGE OFFSET, PAGE SIZE, TOTAL PAGES etc..
   */





 

     // Fetch supplier data with limit, offset, and optional search parameter
   getBuyerData(limit: number, offset: number, searchParam: string = ''): Observable<{ rows: any[], totalElements: number }> {
      const apiUrl = `/settings/buyer/data?limit=${limit}&offset=${offset}&searchParam=${encodeURIComponent(searchParam)}`;
      return from(this.webApiService.getRequest1<{  rows: any[], totalElements: number }>(apiUrl))
      
    }

  resendBuyerCredentials(userIds: number[]): Promise<any> {
    const apiUrl = `/buyer/resendCredentials`;
    return this.webApiService.postRequest<any>(apiUrl, { userIds });
  }

  /** Checks whether the selected supplier is valid or not */
  isValidBuyer(_selectedBuyer: Buyer) {
    return new Promise<Buyer | null>((resolve, reject) => {
      if (
        _selectedBuyer !== null &&
        _selectedBuyer !== undefined &&
        _selectedBuyer
      ) {
        this.getBuyerById(_selectedBuyer.id).then((dbBuyer) => {
          if (
            dbBuyer.id == _selectedBuyer.id &&
            dbBuyer.mpsBuyerCode == _selectedBuyer.mpsBuyerCode &&
            dbBuyer.companyName == _selectedBuyer.companyName
          ) {
            resolve(dbBuyer);
          } else {
            this.snack.open(`${"Selected Buyer Not Valid!"}`, "OK", {
              duration: 3000,
            });
          }
        }).catch((error: HttpErrorResponse) => {
          //console.log(error);
          this.snack.open(`${"Selected Buyer Not Valid!"}`, "OK", {
            duration: 3000,
          });
          reject("Buyer rejected");
        });
      } else {
        resolve(null);
      }
    });
  }


  fetchVesselsByIMONumber(IMONumber: string): Promise<any> {

      let apiUrl = `/search/vessel/fetchVesselByIMONumber/${IMONumber}`;
      return this.webApiService.getRequest<any>(apiUrl);
    
  }
   /*My work Akarsh Singh start date 30th June */
  importBuyersByAdmin(reqBody: any): Promise<any> {
    let apiUrl = `/buyer/importAllBuyersByAdmin`;
    return this.webApiService.postRequest<any>(apiUrl, reqBody);
  }
  exportAllBuyersByAdmin(): Observable<{ rows: any[]}> {
    let apiUrl = `/buyer/exportAllBuyersByAdmin`;
    return from( this.webApiService.getRequest<{ rows: any[]}>(apiUrl));
  }



  addTaxDetails(reqBody: any): Promise<any> {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.addTaxDetails,
      reqBody
    );
  } 

  importTaxDetails(reqBody: any): Promise<any> {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.importTaxDetails,
      reqBody
    );
  }

  updateTaxDetails(reqBody: any): Promise<any> {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.updateTaxDetails,
      reqBody
    );
  }
  async getTaxDetails(reqBody: any): Promise<any> {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.getTaxDetails,
      reqBody
    );
  }

  async getTaxDetailsByRfqToken(reqBody: any): Promise<any> {
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.getTaxDetailsByRfqToken,
      reqBody,
      options
    );
  }
}

 
